<template>
  <MessageToaster :visible="true"/>
  <router-view></router-view>
    <subscription-packages-modal
    :visiblePackagesModal="visiblePackagesModal"
    :remainingDay="remainingDay"
    :isSubscriptionExpired="isCloseable"
    @handle-close="closeSubscriptionPackagesModal"
    ></subscription-packages-modal>

    <ActNowLetterModal
    :visible="visibleActNowLetterModal"
    @handle-close="emptyActNowLetterId()"    
    ></ActNowLetterModal>

    <GlocalFeedBackForm
      :visible="isSurveyFormLive"
      @handle-close="toggleSurveyForm"    
    ></GlocalFeedBackForm>

</template>

<script>
import MessageToaster from './components/BaseComponents/MessageToaster.vue';
import { mapGetters, mapActions } from 'vuex/dist/vuex.cjs.js';
import Cookies from "js-cookie";
import { defineAsyncComponent } from 'vue'
import { __initiateSurveyForm } from "@/store/helpers/profile.helper.js"

export default {
  name: "App",
  components: {
    MessageToaster,
    SubscriptionPackagesModal: defineAsyncComponent(() => import('@/components/BaseComponents/Subscription/SubscriptionPackagesModal.vue')),
    ActNowLetterModal: defineAsyncComponent(() => import('@/components/BaseComponents/ActNow/ActNowLetterModal.vue')),
    GlocalFeedBackForm: defineAsyncComponent(() => import('@/components/SurveyForms/GlocalFeedBackForm.vue')),
    // BotWidget
  },
  data: () =>({
    remainingDay: null,
    alertModalVisibilty: false,
    isCloseable: false,
    alertDays: [7, 3, 1],
    visibleActNowLetterModal: false,
    isSurveyFormLive: false
  }),
  computed:{
    ...mapGetters({
      visiblePackagesModal: 'auth/getSubscriptionPackagesModalVisibility',
      getUserId: 'auth/getUserId',
      sharedActNowLetterId: 'discover/sharedActNowLetterId',
      hasSubmittedFeedbackQna: 'profile/hasSubmittedFeedbackQna',
      feedBackFormTriggered: 'profile/triggerFeedBackForm',
      authProfileSettings: 'profile/authProfileSettings',
      isThirdLogin: 'profile/isThirdLogin',
      openInitialTopicModal: 'discover/openInitialTopicModal',
      userInformation: 'profile/userInformation'
    }),
    userProfile() {
      return this.$store.getters["profile/userInformation"];
    },
    startDate() {
      return Object.keys(this.userProfile).includes("active_subscription") &&
        this.userProfile.active_subscription !== null
        ? this.$store.getters["profile/userInformation"].active_subscription
            .start_date
        : "";
    },
    endDate() {
      return Object.keys(this.userProfile).includes("active_subscription") &&
        this.userProfile.active_subscription !== null
        ? this.$store.getters["profile/userInformation"].active_subscription
            .end_date
        : "";
    },
    isSubscriptionExpired() {
      return Object.keys(this.userProfile).includes("active_subscription") &&
        this.userProfile.active_subscription !== null
        ? this.userProfile.active_subscription.is_expired
        : false;
    },
    showFreemiumAlertDays() {
      return Cookies.get("show_btn_once");
    },
    welcomeToGlocal: {
      get() {
        return this.userProfile.first_login_attempt;
      },
    },
    subscribePlans(){
      return this.$store.getters['auth/getSubscriptionPlans'];
    },
  },
  watch: {
      $route: {
          immediate: true,
      handler(to) {
        this.displayChatBotIcon()
              document.title = to.meta.title || 'Glocal';

          if (this.userProfile.is_paid === false && this.subscribePlans.length > 0 && this.$route.name !== 'landing-page-V2'){
            this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
          }else{
            this.checkAlertStatus();
          }
      }
      },
      'userProfile.is_paid':{
        handler(has_paid){
          if (has_paid === false && this.subscribePlans.length > 0 && this.$route.name !== 'landing-page-V2'){
            this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
          }else{
            this.checkAlertStatus();
          }
        }, immediate: true
      },
      subscribePlans:{
        handler(plans){
          if (this.userProfile.is_paid === false && plans.length > 0 && this.$route.name !== 'landing-page-V2'){
            this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
          }else{
            this.checkAlertStatus();
          }
        },immediate: true
      },
      welcomeToGlocal:{
        handler(isOpen){
          this.isCloseable = isOpen
        },
        immediate: true
      },
      getUserId:{
        handler(val){
          if (val){
            this.initiateNotificationSocketConnection()
          }
        }, immediate:true
      },
      sharedActNowLetterId:{
        handler(val){
          if (val){
            this.visibleActNowLetterModal = true
          }else{
            this.visibleActNowLetterModal = false
          }
        }, immediate:true
      },
      hasSubmittedFeedbackQna:{
        handler(val){
          if (val && this.userInformation.id){
            this.toggleSurveyForm()
          }
        }, immediate:true
      },
      feedBackFormTriggered:{
        handler(isTriggered){

          if (isTriggered){
            const surveyFormClosedStatus = localStorage.getItem('has_feedback_form_closed')
            if (isTriggered
            && !this.userInformation.profile?.has_submitted_feedback_qna 
            && this.isThirdLogin 
            && surveyFormClosedStatus === 'false'
            && !this.openInitialTopicModal && this.userProfile.is_paid !== false
            && this.userInformation.id
          ){
              __initiateSurveyForm(this.$store)
            }
            else{
                this.setTriggerFeedBackForm(false)
            }
        }
        }, immediate:true
      }
  },
  mounted(){
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          // do something if page loaded from bfcache
          if (this.userProfile.is_paid === false){
            this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
          }else{
            this.checkAlertStatus();
          }
        }
      });
      window.addEventListener('click', (event) => {
        if (!this.feedBackFormTriggered){
          this.setTriggerFeedBackForm(true)
        }
      })

      this.emitter.on('lock-scroll', (lock)=> {
        if (lock){
          document.documentElement.classList.add('no-scroll')
          document.body.classList.add('no-scroll')
        }else{
          document.documentElement.classList.remove('no-scroll')
          document.body.classList.remove('no-scroll')
        }
      })
       
  },
  methods: {
    ...mapActions({
      initiateNotificationSocketConnection: 'notification/initiateNotificationSocketConnection',
      setSharedActNowLetterId: 'discover/setSharedActNowLetterId',
      setShareActNowLetterArticleLink: 'discover/setShareActNowLetterArticleLink',
      setFeedbackSurveyFormStatus: 'profile/setFeedbackSurveyFormStatus',
      setTriggerFeedBackForm: 'profile/setTriggerFeedBackForm',
    }),
    /**
     * used to toggle the display of the chatbot icon 
     */
    displayChatBotIcon() {
      //check if chat bot has been initiaillized and the current route is '/'
      if (document.getElementById("bp-web-widget-container") && window.location.pathname === '/') {
        // get the attributes of the chatbot div 
        let chatBot = document.getElementById("bp-web-widget-container")
        // set style to none
        chatBot.style.display = 'none'
      }
      else if (document.getElementById("bp-web-widget-container") && window.location.pathname !== '/') {
        // get the attributes of the chatbot div
        let chatBot = document.getElementById("bp-web-widget-container")

        // if the current page is not the landing page and the style is not set to block
        if (chatBot.style.display === 'none')
          chatBot.style.display = 'block'
      }
      
    },
    checkAlertStatus() {
      const parseDate = (dateString) => {
        const [day, month, year] = dateString.split("-");
        return new Date(`${month}/${day}/${year}`);
      };

      const startDate = parseDate(this.startDate);
      const endDate = parseDate(this.endDate);
      const currentDate = new Date();

      const remainingDays = Math.ceil(
        (endDate - currentDate) / (1000 * 60 * 60 * 24)
      );
      if (this.isSubscriptionExpired) {
        this.remainingDay = null;
        // this.alertModalVisibilty = true;
        this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
        this.isCloseable = false;
      } else if (
        !this.showFreemiumAlertDays ||
        this.showFreemiumAlertDays === "false"
      ) {
        if (this.alertDays.includes(remainingDays)) {
          this.remainingDay = remainingDays;
          // this.alertModalVisibilty = true;
          this.$store.commit("auth/setSubscriptionPackagesVisibilty", true);
          this.isCloseable = true;
        }
      } else {
        if (!this.alertDays.includes(remainingDays)) {
          Cookies.set("show_btn_once", false, { expires: 30 });
        }
      }
    },
    closeSubscriptionPackagesModal() {
      this.$store.commit("auth/setSubscriptionPackagesVisibilty", false);
      Cookies.set("show_btn_once", true, { expires: 30 });
    },
    emptyActNowLetterId() {
      this.setSharedActNowLetterId('')
      this.setShareActNowLetterArticleLink('')
    },
    toggleSurveyForm(){ 
      this.isSurveyFormLive = !this.isSurveyFormLive
      if (!this.isSurveyFormLive){
        this.setFeedbackSurveyFormStatus(false)
      }
    }
  }
};
</script>

<style lang='scss'>
@import "./assets/icons/icons.css";
.no-scroll{
  overflow: hidden !important;
}
</style>
